<template>
  <MenuButton
    as="template"
    @keydown.capture="handleKeydown"
    :disabled="props.disabled"
  >
    <button :class="classes">
      {{ props.label }}
      <ChevronDownIcon
        class="-mr-1 ml-2"
        :class="iconSize"
        aria-hidden="true"
      />
    </button>
  </MenuButton>
</template>

<script setup>
import { MenuButton } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'
import { useButtonClasses } from '../Buttons/common'
import { buttonSizeToIconSizeMap, iconSizeClasses } from '../common'

const props = defineProps({
  label: {
    type: [String, Number],
    default: 'Options',
  },
  size: {
    type: String,
    default: 'lg',
  },
  color: {
    type: String,
    default: 'white',
  },
  shape: {
    type: String,
    default: 'default',
  },
  rounded: {
    type: String,
    default: null,
  },
  disabled: Boolean,
})

const classes = useButtonClasses(props)

const iconSize = computed(() =>
  iconSizeClasses(buttonSizeToIconSizeMap(props.size))
)

function handleKeydown(event) {
  // Disable the up and down arrow keys from opening the menu.
  // It interferes with our useArrowKeyDirection (opens the menu on up or down key press instead of focusing element above or below).
  // HeadlessUI checks for keydown of up and down and opens the menu, so we can capture the event first and stop propagation.
  if (event.keyCode === 38 || event.keyCode === 40) {
    event.preventDefault()
    event.stopPropagation()
  }
}
</script>
